import type { SupportContent } from "../types";

export const support: SupportContent = {
  meta: {
    title: "Support & Help Center | Flex Fund Prop Firm",
    description:
      "Get help from real humans. Email support and a searchable FAQ knowledge base — fast responses for funded traders and prospects, 24/7.",
  },
  hero: {
    line1: "Real humans.",
    line2Highlight: "Fast answers.",
    lede: "Email our team or search the FAQ library. Average first reply under four hours.",
  },
  channels: {
    email: {
      name: "Email",
      // The address itself is an identifier and is injected by the component
      // from SUPPORT_EMAIL, never restated per locale.
      desc: "",
      cta: "Send email",
      meta: "AVG REPLY < 4 hours",
    },
    helpCenter: {
      name: "Help Center",
      desc: "Searchable FAQ knowledge base",
      cta: "Open FAQs",
      meta: "24/7 · INSTANT ANSWERS",
    },
  },
  faqPanel: {
    titleLead: "Browse the ",
    titleHighlight: "FAQ library",
    body: "Most answers live on the Flex Fund knowledge base — payouts, rules, account, platform, billing.",
  },
  form: {
    heading: "Send a message",
    namePlaceholder: "Your name",
    emailPlaceholder: "Email",
    messagePlaceholder: "Tell us what's going on…",
    submit: "Send message",
    sent: "Email opened ✓",
    topics: {
      account: "Account",
      payouts: "Payouts",
      rules: "Rules",
      platform: "Platform",
      billing: "Billing",
    },
    footnote: "OPENS YOUR EMAIL CLIENT · REPLY UNDER 4 HOURS · 24/7",
  },
  widget: {
    dialogLabel: "Send a message to support",
    openTrigger: "Open support form",
    closeTrigger: "Close support form",
    closePanel: "Close support form",
    heading: "Send us a message",
  },
};
